module.exports = __webpack_public_path__ + "static/media/loader.d4e8a42a.gif";